const SURCHARGE_EVENT_LABELS = {
  blackouts: "Blackouts Dates",
  special_event: "Special Event",
  weekend_dates: "Weekend Fees",
  night_fees: "Night Fees",
  seasonal: "Seasonal Fees",
  availability_on_request: "Availability on Request"
};

function getSurchargeLabel(event) {
  return SURCHARGE_EVENT_LABELS[event] || event;
}

function getActiveNetSurcharges(surcharges = []) {
  return surcharges.filter(
    surcharge => surcharge.status && surcharge.apply_in === "net"
  );
}

export function buildNetPriceDetails(netPrice, netPriceComposition = [], surcharges = []) {
  const netSurcharges = getActiveNetSurcharges(surcharges);

  const basePrice = netPriceComposition.reduce(
    (total, item) => total + item.basePrice,
    0
  );

  const details = [
    ...netPriceComposition.map(item => ({
      type: item.type,
      name: item.name || item.type,
      amount: item.basePrice
    })),
    ...netSurcharges.map(surcharge => ({
      type: surcharge.event,
      name: getSurchargeLabel(surcharge.event),
      amount:
        surcharge.type === "percentage"
          ? basePrice * (surcharge.value / 100)
          : surcharge.value
    }))
  ].map(detail => ({
    ...detail,
    amount: parseFloat(detail.amount.toFixed(2))
  }));

  if (details.length > 0) {
    const detailsTotal = details.reduce((sum, detail) => sum + detail.amount, 0);
    const roundingDiff = parseFloat((netPrice - detailsTotal).toFixed(2));
    if (roundingDiff !== 0) {
      const lastDetail = details[details.length - 1];
      lastDetail.amount = parseFloat((lastDetail.amount + roundingDiff).toFixed(2));
    }
  }

  return details;
}
